export default "__VITE_ASSET__e4c4718b__"